import React, { useState, useLayoutEffect } from 'react';
import LeaseBasicSettings from './components/LeaseBasicSettings.js.jsx';
import LineItems from './components/LineItems.js.jsx';
import LeaseCustomFieldGroup from './components/LeaseCustomFieldGroup.js.jsx';
import DocumentTemplatesSection from './components/DocumentTemplatesSection.js.jsx';

const LeaseDetailsForm = ({
  emailTemplates = [],
  feeStructures = [],
  securityDepositItems = [],
  documentTemplates = [],
  leaseCustomFields = [],
  customFieldTypeGroups = [],
  initialData = {},
  reinstate = false,
  tenantTermOverride = 'Tenant',
}) => {
  const [expandedGroups, setExpandedGroups] = useState({});

  const [sdItems, setSdItems] = useState([0]);

  const addSdItem = () => setSdItems((prev) => [...prev, prev.length]);
  const removeSdItem = (index) =>
    setSdItems((prev) => prev.filter((_, i) => i !== index));

  const securityDepositOptions = (securityDepositItems || []).map((item) =>
    Array.isArray(item)
      ? { value: item[1], label: item[0] }
      : { value: item.value, label: item.label }
  );

  useLayoutEffect(() => {
    const container = document.getElementById('new-lease-form');
    window.mdc.autoInit(container);
    window.attachFormatMoneyListener();
    window.initDatepicker('#new-lease-form');
    window.initDateTimepicker('#new-lease-form');
    window.initSelect2('#new-lease-form');
  }, [sdItems]);

  const toggleGroupExpansion = (groupId) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [groupId]: !prev[groupId],
    }));
  };

  let fieldIndex = 0;
  const customFieldGroups = [];

  if (leaseCustomFields.length > 0) {
    customFieldGroups.push(
      <LeaseCustomFieldGroup
        key="lease-custom-fields"
        groupName="Lease"
        groupId="lease-custom-fields"
        fields={leaseCustomFields}
        basePath="lease[custom_fields_attributes]"
        startIndex={fieldIndex}
        isExpanded={expandedGroups['lease-custom-fields'] || false}
        onToggle={() => toggleGroupExpansion('lease-custom-fields')}
      />
    );
    fieldIndex += leaseCustomFields.length;
  }

  customFieldTypeGroups.forEach((group, index) => {
    if (!group.customFields || group.customFields.length === 0) return;

    const groupId = `lease-custom-field-group-${index}`;
    customFieldGroups.push(
      <LeaseCustomFieldGroup
        key={groupId}
        groupName={group.name}
        groupId={groupId}
        fields={group.customFields}
        basePath="lease[custom_fields_attributes]"
        startIndex={fieldIndex}
        isExpanded={expandedGroups[groupId] || false}
        onToggle={() => toggleGroupExpansion(groupId)}
      />
    );
    fieldIndex += group.customFields.length;
  });

  return (
    <>
      <LeaseBasicSettings
        emailTemplates={emailTemplates}
        feeStructures={feeStructures}
        initialData={initialData}
      />

      <LineItems
        wrapperId="security-deposit-fields"
        itemType="security-deposit-item"
        newButtonId="new-security-deposit-item"
        items={sdItems}
        onAdd={addSdItem}
        onRemove={removeSdItem}
        defaultAmount={initialData.securityDepositAmount || '0.00'}
        selectLabel="Security Deposit Item"
        selectOptions={securityDepositOptions}
        selectDefaultValue={initialData.securityDepositItemId || ''}
        namePattern={`lease[security_deposit_line_items][{{index}}][{{field}}]`}
      />

      {!reinstate &&
        (leaseCustomFields.length > 0 ||
          customFieldTypeGroups.some(
            (group) => group.customFields && group.customFields.length > 0
          )) && (
          <>
            <hr />
            <h3>Custom Fields</h3>
            {customFieldGroups}
          </>
        )}

      <DocumentTemplatesSection
        documentTemplates={documentTemplates}
        initialSelectedTemplates={initialData.documentTemplateIds || []}
        tenantTermOverride={tenantTermOverride}
        reinstate={reinstate}
      />
    </>
  );
};

export default LeaseDetailsForm;
